import React from 'react'
import { FaChevronDown } from 'react-icons/fa'

import { StyledButton, ImgContainer } from './styles'

const SortingDropdownButton = ({ onClick, countBadge, ...rest }) => {
  return (
    <StyledButton primary type="button" onClick={onClick} {...rest}>
      Sort By{' '}
      <ImgContainer>
        <FaChevronDown />
      </ImgContainer>
    </StyledButton>
  )
}

export default SortingDropdownButton
